import { render, staticRenderFns } from "./organization-offices.vue?vue&type=template&id=65fad4f5&scoped=true&"
import script from "./organization-offices.vue?vue&type=script&lang=js&"
export * from "./organization-offices.vue?vue&type=script&lang=js&"
import style0 from "./organization-offices.vue?vue&type=style&index=0&id=65fad4f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fad4f5",
  null
  
)

export default component.exports